
export const sendStats = (player, id) => {
	const stats = { id };
	const array = [];
	let key;
	
	player.on("timeupdate", function() {
		array.push( Math.round( player.currentTime() ) );
	});

	if ( !sessionStorage.getItem('key') ) {
		key = Date.now();
		sessionStorage.setItem('key', key);
	} 
	else 
	{
		key = sessionStorage.getItem('key');
	}

	const sendstat = () => {
		const setSecondsArray = [...new Set([...array])];	
		const result = [];
		
		for (let i = 0; i < setSecondsArray.length; i++) {

			if (i === 0) result.push({start: setSecondsArray[0]});

			if ( !setSecondsArray[i + 1] ) {
				result[result.length - 1].end = setSecondsArray[i];
			} else if (setSecondsArray[i + 1] - 1 !== setSecondsArray[i]) {
				result[result.length - 1].end = setSecondsArray[i];
				result.push({start: setSecondsArray[i + 1]});
			}
		}

		stats.time_intervals = result;
		stats.key = key;
		stats.time_percent = Math.round((setSecondsArray.length) / player.cache_.duration * 100);
		
		fetch( '/ajax/', {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
			},
			body: `action=stat&data=${JSON.stringify(stats)}`,
		} )
			.then( ( response ) => {
				if ( !response.ok )
				{
					throw new Error( `Could not fetch, status: ${response.status}` );
				}
				return response.json();
			} )
	}

	document.onvisibilitychange = function() {
		sendstat();
		array.length = 0;
	};

	window.onbeforeunload = function() {
		sendstat();
		array.length = 0;
	};

	player.on("ended", function() {
		sendstat();
		array.length = 0;
	});
}